import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";
import { usePagarQuinzena } from "@/hooks/use-equipe";
import { useToast } from "@/hooks/use-toast";
import { formatarBRL } from "@shared/equipe-fechamento";
import type { Quinzena } from "@shared/schema";

interface PagarQuinzenaDialogProps {
  open: boolean;
  onClose: () => void;
  quinzena: Quinzena;
  /**
   * Total a sair da quinzena (folha do diarista + adicionais + adiantamentos
   * do mensalista) — o MESMO `totalASair` do rodapé "Sai em" da tela principal
   * (financeiro.tsx), não `quinzena.totalBruto` (que é só a folha do diarista,
   * congelada no fechamento). Mesmo bug do modal "Fechar Quinzena" — v2.10 —
   * reaproveitado aqui em vez de duplicado.
   */
  totalASair: string;
}

export function PagarQuinzenaDialog({ open, onClose, quinzena, totalASair }: PagarQuinzenaDialogProps) {
  const pagar = usePagarQuinzena();
  const { toast } = useToast();

  const handlePagar = async () => {
    try {
      await pagar.mutateAsync({ id: quinzena.id });
      toast({ title: "Quinzena marcada como paga!" });
      onClose();
    } catch {
      toast({ title: "Erro ao marcar quinzena como paga", variant: "destructive" });
    }
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Marcar como Paga</DialogTitle>
        </DialogHeader>

        <div className="flex items-center gap-3 p-3 rounded-md bg-sucesso-suave border border-sucesso/30 text-sucesso text-sm">
          <CheckCircle2 className="h-4 w-4 shrink-0" />
          <span>Total a pagar: <strong>{formatarBRL(totalASair)}</strong></span>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={handlePagar} disabled={pagar.isPending}>
            {pagar.isPending ? "Salvando..." : "Confirmar Pagamento"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
